export const SETTINGS_ROUTING = {
  Branding: 'branding',
  Versions: 'versions',
  Support: 'support',
  PlatformAccess: 'platform-access',
  Nps: 'nps',
  Trackers: 'trackers',
  SignMethods: 'sign-in-methods',
  Widget: 'widget',
  Menu: 'Menu',
  Profile: 'profile',
} as const;
